module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/tank-not-available-CN.6b3b2802.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/tank-not-available-CN.png
// module id = 3042
// module chunks = 11